export function formatExecutionTime(timeInMs: number | null) {
  if (!timeInMs) return "-"
  if (timeInMs >= 1000) {
    return Math.ceil(timeInMs / 1000) + "s"
  }

  return Math.ceil(timeInMs) + "ms"
}